import { hasValue } from '../common';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridColumn } from './dataGrid.types';
import { DxFormItem } from './types';

export type DxFormItemExtended = DxFormItem & {
    items?: DxFormItemExtended[];
} & { label?: { _translate?: boolean, text?: string } };

/**
 * Returns mapper function for automatically setting DX Form Items' labels based on their data field keys.
 *
 * @param translate The ngx-translate service.
 * @param dictionaryPath The root path in which keys are available in the translation files.
 */
export const mapFormAddTranslatedLabels = (
    translate: TranslateService,
    dictionaryPath: string,
) => {
    return (formItem: DxFormItemExtended) => {
        if (formItem.label && formItem.label.text && formItem.label._translate) {
            formItem.label.text = translate.instant(formItem.label.text!);
            formItem.label._translate = false;
        }
        if ('dataField' in formItem && formItem.dataField) {
            if (!formItem.label) {
                formItem.label = {
                    visible: !hasValue(formItem.template),
                };
            }

            if (!formItem.label.text)
                formItem.label.text = translate.instant(
                    `${dictionaryPath ? dictionaryPath + '.' : ''}${formItem.dataField}`,
                );
        }
        if (formItem.itemType == 'group' && 'items' in formItem) {
            formItem.items = formItem.items?.map(
                mapFormAddTranslatedLabels(translate, dictionaryPath),
            );
        }
        return formItem;
    };
};

export const mapFormAddEditorNames = (
    predicate: (dataField: string) => string,
) => {
    return (formItem: any) => {
        if ('dataField' in formItem && formItem.dataField) {
            if (!formItem.editorOptions) {
                formItem.editorOptions = {};
            }
            formItem.name = formItem.editorOptions.name = predicate(
                formItem.dataField,
            );
        }
        if (
            formItem.itemType == 'group' &&
            formItem.items &&
            formItem.items.length
        ) {
            formItem.items = formItem.items.map(
                mapFormAddEditorNames(predicate),
            );
        }
        return formItem;
    };
};

export const mapGridColumnsAddCaption = (
    translate: TranslateService,
    dictionaryPath: string,
) => {
    return (column: DxDataGridColumn) => {
        if ('dataField' in column && column.dataField)
            column.caption = translate.instant(
                `${dictionaryPath ? dictionaryPath + '.' : ''}${column.dataField}`,
            );

        if (column.columns && column.columns?.length)
            column.columns = (column.columns as DxDataGridColumn[]).map(
                mapGridColumnsAddCaption(translate, dictionaryPath),
            );

        return column;
    };
};

export const mapFormForceReadOnly = () => {
    return (formItem: any) => {
        if ('dataField' in formItem && formItem.dataField) {
            if (!formItem.editorOptions) {
                formItem.editorOptions = {};
            }
            formItem.editorOptions.readOnly = true;
        }
        if (
            formItem.itemType == 'group' &&
            formItem.items &&
            formItem.items.length
        ) {
            formItem.items = formItem.items.map(mapFormForceReadOnly());
        }
        return formItem;
    };
};
